/**
 * The wishlist integrations JS functionality.
 */

class qalaDepict {
	constructor() {
		wp.hooks.addFilter( 'qala_depict.filter.after_product_card_images', 'QalaQuickview', this.addQuickviewButton );
	}

	/**
	 * Populates the wishlist template with the content.
	 *
	 * @param {string} html
	 * @param {Object} productData
	 */
	addQuickviewButton = ( html, productData ) => {
		// Bail if product data is empty.
		if ( Object.keys( productData ).length === 0 ) {
			return;
		}

		productData.product_type = 'simple';
		// Infer the product type by comparing store_group_id with store_product_id. If they are not the same we are likely looking at a variable product.
		if ( productData?.store_group_id && productData.store_product_id !== productData.store_group_id ) {
			productData.product_type = 'variable';
		}

		// Use the label as defined in Depict settings primarily. If that is not set we try to use the one from QalaBuy.
		productData.buttonLabel = QalaDepict?.settings?.add_to_cart_label ?? QalaBuy.settings.button_label; // eslint-disable-line no-undef
		// Final fallback, shouldn't happen.
		if ( ! productData?.buttonLabel ) {
			productData.buttonLabel = 'Add to cart';
		}

		// Fallback for disabled state. It needs to default to "no".
		if ( ! productData?.disabled ) {
			productData.disabled = 'no';
		}

		// Safeguard against missing or incorrect data from Depict.
		// In theses cases we will disable the quick buy functionality using the disabled parameter.
		// * store_product_id or store_group_id is empty
		// * store_product_id matches product_id (SKU)
		// * store_group_id matches product_id (SKU)
		if ( QalaBuy.settings.depict_safeguard === 'yes' ) {
			if (
				( ! productData.store_group_id || ! productData.store_product_id ) ||
				( productData?.store_group_id === productData?.product_id ) ||
				( productData?.store_product_id === productData?.product_id )
			) {
				productData.disabled = 'yes';
			}
		}

		const buttonWrapperElement = document.createElement( 'div' );
		buttonWrapperElement.classList.add( 'quickview-product' );
		const buttonTemplate = wp.template( 'quickview-productcard-button' );
		buttonWrapperElement.innerHTML = buttonTemplate( productData );

		return buttonWrapperElement.outerHTML;
	};
}

export default qalaDepict;
